import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { store, persistor } from '@/store';
import { queryClient } from './queryClient';
import { router } from '@/routes';
import { ThemeSync } from '@/components/common/ThemeSync';
import { PageLoader } from '@/components/common/PageLoader';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';

export function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={200}>
            <ThemeSync />
            <Suspense fallback={<PageLoader />}>
              <RouterProvider router={router} />
            </Suspense>
            <Toaster />
          </TooltipProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}
